export const sidebarItems = [
  {
    id: 0,
    label: "Dashboard",
    constant: "dashboard",
    icon: "ri-dashboard-line",
    path: "/dashboard",
    badgeColor: "success",
    badgeName: "",
    moduleaccess: true,
    viewonly: false,
    iseditaccess: true
  },
  
  {
    id: 1,
    label: "Users",
    constant: "users",
    icon: "ri-group-line",
    path: "/user",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: false,
    iseditaccess: true
  },
  {
    id: 2,
    label: "Reports",
    constant: "reports",
    icon: "ri-file-transfer-line",   
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false,
    subItems: [
      {
        id: 61,
        label: "Transaction Report",
        constant: "transactionreport",
        path: "/transactionreport",
      },
      {
        id: 62,
        label: "Goals Report",
        constant: "goalreport",
        path: "/goalreport",
      },
    ],
  },
  {
    id: 3,
    label: "Tickets & Feedback",
    constant: "ticket",
    icon: "ri-mail-line",   
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false,
    subItems: [
      {
        id: 51,
        label: "Tickets",
        constant: "ticket",
        path: "/ticket",
      },
      {
        id: 52,
        label: "Feedback & Analytics",
        constant: "ticketfeedback",
        path: "/ticketfeedback",
      },
    ],
  },
  {
    id: 4,
    label: "Masters",
    constant: "masters",
    icon: "ri-file-text-line",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false,
    subItems: [
      {
        id: 21,
        label: "Goal Category",
        constant: "goalcategory",
        path: "/goalcategory",
      },
      {
        id: 22,
        label: "Goal Sub Category",
        constant: "goalsubcategory",
        path: "/goalsubcategory",
      },
    ],
  },
  {
    id: 5,
    label: "RBAC Control",
    constant: "masters",
    icon: "ri-settings-5-line",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false,
    subItems: [
      {
        id: 31,
        label: "User Type",
        constant: "usertype",
        path: "/usertype",
      },
      {
        id: 32,
        label: "Role Master",
        constant: "rolemaster",
        path: "/rolemaster",
      },
      {
        id: 33,
        label: "Permission Master",
        constant: "permissionmaster",
        path: "/permissionmaster",
      },
      {
        id: 34,
        label: "Role Permission Master",
        constant: "rolepermissionmaster",
        path: "/rolepermissionmaster",
      },
      {
        id: 35,
        label: "Application Master",
        constant: "applicationmaster",
        path: "/applicationmaster",
      },
      {
        id: 36,
        label: "Module Master",
        constant: "modulemaster",
        path: "/modulemaster",
      },
      {
        id: 37,
        label: "Task Master",
        constant: "taskmaster",
        path: "/taskmaster",
      },
      {
        id: 38,
        label: "Role Task Master",
        constant: "roletaskmaster",
        path: "/roletaskmaster",
      },
      {
        id: 39,
        label: "User Master",
        constant: "usermaster",
        path: "/usermaster",
      },
      // {
      //   id: 38,
      //   label: "User Role Master",
      //   constant: "userrolemaster",
      //   path: "/userrolemaster",
      // },
      {
        id: 40,
        label: "Menu Master",
        constant: "menumaster",
        path: "/menumaster",
      },
      {
        id: 41,
        label: "Menu Permission Master",
        constant: "menupermissionmaster",
        path: "/menupermissionmaster",
      },
      {
        id: 42,
        label: "Role Menu Master",
        constant: "rolemenumaster",
        path: "/rolemenumaster",
      },
    ],
  },
  {
    id: 6,
    label: "Leads",
    constant: "lead",
    icon: "ri-team-line",   
    path: "/lead",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false
  },
    {
    id: 7,
    label: "AI Module",
    constant: "course",
    icon: "ri-cpu-line",   
    path: "/course",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false
  },
  {
    id: 8,
    label: "Tips",
    constant: "tips",
    icon: "ri-lightbulb-flash-line",   
    path: "/tips",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false
  },
  {
    id: 9, 
    label: "Insurance",
    constant: "insurance",
    icon: "ri-shield-user-line",    
    path: "/insurance",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false
  },
  {
    id: 10, 
    label: "FAQs",
    constant: "faq",
    icon: "ri-question-answer-line",    
    path: "/faq",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false
  },
  {
    id: 11,
    label: "Doorstep Delivery",
    constant: "doorstepdelivery",
    icon: "ri-dropbox-fill",   
    path: "/doorstepdelivery",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true, 
    viewonly: true,
    iseditaccess: false
  },
  // {
  //   id: 10,
  //   label: "Settings",
  //   constant: "ticket",
  //   icon: "ri-settings-5-line",   
  //   path: "/settings",
  //   badgeColor: "success",
  //   badgeName: "New",
  //   moduleaccess: true,
  //   viewonly: true,
  //   iseditaccess: false
  // },
  {
    id: 12,
    label: "Logout",
    constant: "logout",
    icon: "ri-shut-down-line",   
    path: "/logout",
    badgeColor: "success",
    badgeName: "New",
    moduleaccess: true,
    viewonly: true,
    iseditaccess: false
  },
  // {
  //   id: 13,
  //   label: "Bulk Upload",
  //   constant: "bulkupload",
  //   icon: "ri-upload-cloud-line",   
  //   path: "/bulkupload",
  //   badgeColor: "success",
  //   badgeName: "New",
  //   moduleaccess: true,
  //   viewonly: true,
  //   iseditaccess: false
  // },
];
